import { Services } from '@ekhodealer/ekho-common';
import { Divider, Stack } from '@ekhodealer/ekho-common/rev';

import { useGetServicesProvider } from '@common/api/services-providers/useGetServicesProvider';

import { useInventoryNavigation } from '../../hooks/useInventoryNavigation';

import { InventoryStatus } from './vehicle-details/InventoryStatus';
import { MediaDetails } from './vehicle-details/MediaDetails';
import { ModelDetails } from './vehicle-details/ModelDetails';
import { PricingDetails } from './vehicle-details/PricingDetails';
import { UnitDetails } from './vehicle-details/UnitDetails';
import { CosmeticReport } from './CosmeticReport';

export const VehicleDetails = () => {
	const { servicesProviderId } = useInventoryNavigation();
	const { data: sp } = useGetServicesProvider(servicesProviderId ?? '');
	const cosmeticReportEnabled =
		sp?.config[Services.PROGRAM_OWNER]?.cosmeticReportEnabled === true;

	return (
		<Stack>
			<InventoryStatus />
			<Divider />
			<MediaDetails />
			{cosmeticReportEnabled && (
				<>
					<Divider />
					<CosmeticReport />
				</>
			)}
			<Divider />
			<ModelDetails />
			<Divider />
			<UnitDetails />
			<Divider />
			<PricingDetails />
		</Stack>
	);
};
